export default __webpack_public_path__ + "static/media/seat-standard-selected.af7e78b9.svg";